var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/logo_short.svg")}}),_c('div',{staticClass:"logo-title"},[_c('span',[_vm._v("Интегро")]),_c('div',[_vm._v("Администрирование")])])])
}]

export { render, staticRenderFns }